/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    imageBackground: 'linear(270deg, #E6E5EA, #EEEEEE)',
    greyBackgroundOfProductImages:
        'radial-gradient(45.54% 45.54% at 50% 50%, rgba(255, 255, 255, 0) 14.06%, rgba(155, 155, 155, 0.05) 100%)',
    linkGradients: {
        core: ({colorScheme: colorScheme = 'stokkeCore'}) =>
            `linear-gradient(to bottom, transparent 50%, var(--chakra-colors-${colorScheme}-dark) 50%)`,
        special:
            'linear-gradient(to bottom, transparent 50%, var(--chakra-colors-stokkeCore-orange) 50%)',
        black: 'linear-gradient(to bottom, transparent 50%, var(--chakra-colors-stokkeCore-black) 50%)',
        white: 'linear-gradient(to bottom, transparent 50%, var(--chakra-colors-stokkeCore-white) 50%)'
    },
    miscellaneous: 'linear-gradient(to right, orange , yellow, green, cyan, blue, violet)',
    psdpModalGreyBackgroundOfProductImages:
        'linear-gradient(0deg, rgba(244, 243, 243, 0.50) 0%, rgba(244, 243, 243, 0.50) 100%)'
}
